import { FC, useContext, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import WithHeaderandFooter from "../hoc";
import HubSplashScreen from "../pages/splashscreen";
import IdleSession from "src/components/idleSession";

import { PublicRoutes, AuthenticatedRoutes, ManufacturerRoutes, AreaManagerRoutes } from "./AppRoutes";
import { FooterContext } from "src/context/footerContext";
import { AuthContext } from "src/context/authContext";
import { getRemainingTime } from "src/helpers/session";



const HubRoutes: FC = (): JSX.Element => {
  const { isUserAuthorized, isManufacturer,userData } = useContext(AuthContext);
  const { isAccordianShown, changeAccordianVisibility } = useContext(FooterContext);
  const location = useLocation();
  const { manIdleTime } = getRemainingTime()

  useEffect(() => {
    if (isAccordianShown)
      changeAccordianVisibility();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const manufacturerRoutes = ManufacturerRoutes.map((route) => (
    <Route
      key={route.route}
      path={route.route}
      index={route.isIndex}
      element= {
        route.removeHeaderandFooter === false ?
          <WithHeaderandFooter WrappedComponent={route.component} /> : <route.component/>
      }
    />
  ));
  const areaManagerRoutes = AreaManagerRoutes.map((route) => (
    <Route
      key={route.route}
      path={route.route}
      index={route.isIndex}
      element= {
        route.removeHeaderandFooter === false ?
          <WithHeaderandFooter WrappedComponent={route.component} /> : <route.component/>
      }
    />
  ));

  const authentictedRoutes = AuthenticatedRoutes.map((route) => (
    <Route
      key={route.route}
      path={route.route}
      index={route.isIndex}
      element= {
        route.removeHeaderandFooter === false ?
          <WithHeaderandFooter WrappedComponent={route.component} /> : <route.component/>
      }
    />
  ));

  const publicRoutes = PublicRoutes.map((route) => (
    <Route
      key={route.route}
      path={route.route}
      index={route.isIndex}
      element= {
        route.removeHeaderandFooter === false ?
          <WithHeaderandFooter WrappedComponent={route.component} /> : <route.component/>
      }
    />
  ));

  return (
    <>
      <Routes>
        {isUserAuthorized ? (
          isManufacturer ? (
          userData && userData.ref_type === "Manufacturer" ? manufacturerRoutes : areaManagerRoutes
          ) : (
            authentictedRoutes
          )
        ) : (
          publicRoutes
        )}

        <Route path="/" element={<HubSplashScreen />} />
        <Route path="*" element={<HubSplashScreen />} />
      </Routes>

      {isUserAuthorized && isManufacturer && <IdleSession idleTime={manIdleTime} />}
    </>
  );
};

export default HubRoutes;
